import React, { PureComponent, Fragment } from 'react';
import BasketSummary from './basketsummary';
import BasketDetails from './basketdetails';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { currencySign, renderProductTitle } from '../../helpers/utils';
import CapacityModal from './components/capacitymodal';
import BasketDeparture from './basketdeparture';
import { APP_CONTAINER_ID } from '../../config';
import { ProductDetailsView } from '../../actions/analytics';
import { FetchSequenceCapacity } from '../../actions/capacity';
import { FetchCities } from '../../actions/cities';
import { SetTourID, SetCityID } from '../../actions/currentBooking';
import { FetchNationality } from '../../actions/nationality';
import { FetchErrors } from '../../actions/utils';
import Spinner from '../shared/spinner';
import Header from '../shared/header';
import Footer from '../shared/footer';
import { Helmet } from "react-helmet";
import { getCyoaID } from '../../helpers/cyoaHelper';

const queryString = require('query-string');
const qs = queryString.parse(window.location.search);

class ProductBasket extends PureComponent {

  constructor(){
    super();
    this.state = {
      iscyoa:false
    }
    this.onBackClicked = this.onBackClicked.bind(this);
  }


  componentDidMount(){

    const { FetchSequenceCapacity, FetchCities, SetTourID, FetchNationality, FetchErrors } = this.props;


    if(qs.guid !== undefined){
      this.setState({iscyoa: true});

    
      //Fetch sequence capacity and cities data
      FetchSequenceCapacity(qs.guid, qs.style, qs.optionals, qs.city, qs.currency, qs.stops, null, null, qs.bundle, qs.custom, getCyoaID());
      FetchCities(qs.currency, getCyoaID());
      FetchNationality();
      FetchErrors(qs.currency);

      //Set tour id for CYOA tours
      SetTourID(getCyoaID());
    }
  }

  componentDidUpdate(prevProps, prevState) {

      const { product, sequenceCapacity, SetCityID } = this.props;

      //Track product view
      if(product !== prevProps.product){
        ProductDetailsView(product.header);
      }


      if(this.state.iscyoa){
        if(sequenceCapacity !== sequenceCapacity.sequenceCapacity){

          //Set cityID for cyao tours
          if(Object.keys(sequenceCapacity).length > 0){
            SetCityID(sequenceCapacity.sequence[0].transfer ? sequenceCapacity.sequence[0].transfer[0].stop_id : null);
          }
          
        }
      }
  }

  togglePanelSlide(slideType){

    const slide1 = document.querySelector('.basket-product .s1');
    const slide2 = document.querySelector('.basket-product .s2');

    if(slideType === 'slide1'){
      slide1.classList.remove('fadeout');
      slide2.classList.remove('fadein');
      slide2.style.display = "none";
      slide1.style.display = "block";
    }else{
      slide1.classList.add('fadeout');
      slide1.style.display = "none";
      slide2.style.display = "block";
      slide2.classList.add('fadein');
    }
  }

  renderPriceOrDay(iscyoa, regularPrice, days, cyaoPrice){
    const _sequenceSubName = this.props.sequenceCapacity.sub_name;
    const _sequenceNrTrips = this.props.sequenceCapacity.nr_trips;
    const _sequenceDays = this.props.sequenceCapacity.nr_days;

    //Show prices for regular tour or days for CYOA
    if(iscyoa && _sequenceNrTrips>0){
      return (
        <p className="no-margin">
          <svg className="" width="12" height="12" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
            <path fill="#3ABCCB" d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"></path>
          </svg>
          <strong className="blue-text">{_sequenceSubName}</strong> - {_sequenceDays} days trip<span className="orange-text"></span>
        </p>
      )
    } else if(iscyoa && _sequenceNrTrips===0){
      return <p className="no-margin"><strong className="orange-text">{_sequenceSubName}</strong> {_sequenceDays} days trip<span className="orange-text"></span></p>
    }else{
      return '';
    }
  }

  renderProductTitleOrCyoaTitle(iscyoa, props){
    if(iscyoa){
      return props.sequenceCapacity.name
    }else{
      return renderProductTitle(props.product, props.tour_id)
    }
  }

  renderCyaoImages(props){
    if(this.state.iscyoa){
      const citiesList = (props.sequenceCapacity !== undefined && props.sequenceCapacity.sequence) ? props.sequenceCapacity.sequence.map(list => list.city) : [];
      const allCities = props.cities !== undefined ? props.cities : [];
      let arr = [];

      for(let j = 0; j < citiesList.length; j++){
        for(let i = 0; i < allCities.length; i++){
          if(allCities[i].city === citiesList[j]){
            arr.push({
              images:allCities[i].images
            })
          }
        }
      }
      return arr;
    }else{
      //TODO - Non - cyoa images here
      return [];
    }
  }

  onBackClicked(type){
    if(type === 'personal-details') this.togglePanelSlide('slide1');
  }

  render() {

    const { iscyoa } = this.state;
    const { product, sequenceCapacity } = this.props;

    if(Object.keys(product).length === 0 && Object.keys(sequenceCapacity).length === 0){
      return <Spinner text="Loading..." loadClass="orange-spinner-wrapper" />;
    }
    else{

      const {
        product:{header},
        nationality,
        currency,
        processing,
        booking,
        lockout,
        sequenceCapacity:{name, sequence, departures, min_days, sub_name, nr_days, nr_trips},
        currentTrip:{departure_date}
      } = this.props;

      const _adultPrice = (header.prices_from === undefined) ? "" : currencySign(currency.currency_mask) + header.prices_from.adult;
      const _headerTitle = (!iscyoa) ? header.name : name;
      const _sequenceDays = (sequence === undefined) ? "" : min_days;
      const _sequenceAdultPrice = (departures !== undefined && departures.length) ? currencySign(currency.currency_mask) + departures[0].price_adult : "";

 

      return (
        <Fragment>
          <Helmet>
            <title>Departure date | Busabout</title>
          </Helmet>
        <div className="basket-product-wrapper">
        <Header/>
        <div className={`basket basket-product ${(processing || booking) ? 'active' : ''} `}>
          <div className="slides s1">
            <div className="row">
              <div className="column small-12">
                  <h4 className="busabout-h4 no-margin uppercase">{ _headerTitle }</h4>
                  { this.renderPriceOrDay(iscyoa, _adultPrice, _sequenceDays, _sequenceAdultPrice) }
              </div>
            </div>
            <div className="row">
              <div className="column small-12 medium-7 large-8">
                <BasketDetails title="Trip details" basketdetailsclass=""  routeParams={document.getElementById(APP_CONTAINER_ID).dataset.date} iscyoa={iscyoa} />
              </div>
              <div className="column small-12 medium-5 large-4">
                  <BasketSummary title="Summary" basketsummaryclass="" basketType="product" iscyoa={iscyoa} />
              </div>
            </div>


          </div>
          <div className="slides s2">
            <button className="lity-close lity-back productbasket" onClick={() => this.onBackClicked('personal-details')}><i className="arrow left"></i></button>
            <div className="row">
              <div className="column small-12">
                <BasketDeparture
                  headerText={this.renderProductTitleOrCyoaTitle(iscyoa, this.props)}
                  headerPrice={_adultPrice}
                  nationality={nationality}
                  basketType="product"
                  lockout={lockout}
                  iscyoa={iscyoa}
                  headerPriceCyoa={_sequenceAdultPrice}
                  headerDurationCyoa={_sequenceDays}
                  sliderImages={this.renderCyaoImages(this.props)}
                  sequenceSubName={sub_name}
                  sequenceDays={nr_days}
                  sequenceNrTrips={nr_trips}
                  departureDate={departure_date}
                  />
              </div>
            </div>
          </div>
        </div>
        <Footer/>
          <div className={`capacitymodal-container ${(processing || booking) ? 'active' : ''} `}>
            <CapacityModal basketType="product" basketAction={this.togglePanelSlide}/>
          </div>
        </div>
        </Fragment>
      );
    }

  }
}



function mapStateToProps(state){
  return {
     currency:state.currency,
     product:state.product,
     nationality:state.nationality,
     currentTrip:state.currentBooking.trips[0],
     processing:state.currentBooking.processing,
     booking:state.currentBooking.booking,
     capacity:state.capacity.data,
     lockout:state.currentBooking.lockout,
     sequenceCapacity:state.sequenceCapacity.data,
     cities:state.cities.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
  FetchSequenceCapacity,
  FetchCities,
  SetTourID,
  SetCityID,
  FetchNationality,
  FetchErrors
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductBasket);



// WEBPACK FOOTER //
// ./src/components/departure/productbasket.js